define 'controller/ProductLinkController', ['jquery'], ($) ->
  class ProductLinkController

    constructor: (@$el) ->
      @$el.on 'click', (e) =>
        if not @_isColorSlider(e) and not @_isSliderArrow(e)
          page =  @$el.data 'page'
          articleNumber = @$el.data 'articlenumber'
          index = @$el.data 'index'
          index += 1
          that = this
          $.ajax({
              url: "/api/datalayer/category/clickEvent?index=#{index}&page=#{page}&articleNumber=#{articleNumber}",
              type: 'GET',
              success: (data) ->
                try
                  dataLayer.push(JSON.parse(decodeURIComponent(escape(atob(data)))));
                catch error
                  dataLayer.push(JSON.parse(atob(data)))
              complete: () ->
                that._goToDetailpage()
            })

    _goToDetailpage: ->
      link = @$el.find('.article__link').attr('href')
      if link
        window.location.href = link

    _isColorSlider: (e) =>
      return $(e.target).hasClass('article-color-slider') || $(e.target).closest('.article-color-slider').length > 0

    _isSliderArrow: (e) =>
      return $(e.target).closest("[data-controller-element=article-slider-prev]").length > 0 || $(e.target).is("[data-controller-element=article-slider-prev]") || $(e.target).closest("[data-controller-element=article-slider-next]").length > 0 || $(e.target).hasClass("[data-controller-element=article-slider-next]")

    destroy: ->
      @$el.off()